<div class="purchase-receipt">
  <div class="ac-flex ac-ctr">
    <app-purchase-boost-banner [fullWidth]="true" [includeInfoIcon]="false" />
  </div>

  <div class="purchase-receipt__row">
    <span class="purchase-receipt__label ac-body-sm">Gold Coins</span>
    <span class="purchase-receipt__value">
      <app-gc-icon [size]="16" />
      <span class="ac-title-md">{{ goldAmountVM() }}</span>
    </span>
  </div>
  <div class="purchase-receipt__row" sweepsVisible>
    <span class="purchase-receipt__label ac-body-sm">Free Sweeps Coins</span>
    <span class="purchase-receipt__value">
      <app-sc-icon [size]="16" />
      <span class="ac-title-md">{{ sweepsAmountVM() }}</span>
    </span>
  </div>
  <div class="purchase-receipt__divider">
    <span class="purchase-receipt__divider-line"></span>
    <ac-icon iconKey="payment:receipt_logo" [size]="97" [useWidth]="true" />
    <span class="purchase-receipt__divider-line"></span>
  </div>
  <div class="purchase-receipt__row">
    <span class="purchase-receipt__label ac-body-sm">Total</span>
    <span class="purchase-receipt__total ac-title-lg">
      @if (cryptocurrency() && convertedAmount()) {
        {{ convertedAmount() | decimal : cryptocurrency()!.ui_decimals + '-' + cryptocurrency()!.ui_decimals }}
        {{ cryptocurrency()!.ticker }}
        <span class="ac-label">({{ amount() | currency : 'USD' : 'symbol-narrow' }})</span>
      } @else {
        {{ amount() | currency : 'USD' : 'symbol-narrow' }}
      }
    </span>
  </div>
  @if (cryptocurrency()) {
    <div class="purchase-receipt__crypto-note ac-body-sm ac-label">
      This is an estimation based on current conversion rates, it may change by
      the time you exchange currencies.
    </div>
  }
</div>
